import { render } from "./MedicalServices.vue?vue&type=template&id=4645da26"
import script from "./MedicalServices.vue?vue&type=script&lang=js"
export * from "./MedicalServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__